import CaseCTA from './CaseCTA'

export default CaseCTA
export type { CaseCTAProps, CaseCTAItem } from './CaseCTA'
